<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>기탁서 리스트</strong>
          </div>
          <b-row>
            <b-col
              md="5"
              class="text-left"
            >
              <b-input-group
                name="partSet"
                prepend="연도"
                label-for="part"
                class="mb-2"
              >
                <b-form-select
                  v-model="term"
                  :disabled="noAuth"
                  :options="termOptions"
                  @change="getDonateList"
                />
                <b-input-group-append>
                  <b-btn
                    :disabled="noAuth"
                    variant="primary"
                    size="sm"
                    @click="getDonateList(term)"
                  >
                    새로고침
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col
              md="4"
            >
              <b-form-group
                label="Per page"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                label-for="perPageSelect"
                class="mb-0"
              >
                <b-form-select
                  id="perPageSelect"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="5">
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                />
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="3">
              <h4>
                <b-badge
                  variant="dark"
                >
                  <strong>Total: {{ totalRows }}</strong>
                </b-badge>
              </h4>
            </b-col>
          </b-row>
          <b-row
            align-h="center"
            class="text-left"
          >
            <b-table
              class="mb-0 table-outline"
              hover
              :items="itemAll"
              :fields="fieldsAll"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :filter-included-fields="filterOn"
              head-variant="light"
              @filtered="onFiltered"
            >
              <template
                v-slot:cell(part)="data"
              >
                <div>
                  {{ data.value }}
                  <b-badge v-if="data.value !== '개인'">
                    {{ data.item.partName }}
                  </b-badge>
                </div>
              </template>
              <template
                v-slot:cell(nameSchls)="data"
              >
                <b-button
                  variant="outline-success"
                  size="md"
                  @click="showRowDetail(data.item.donateId, data.item._showDetails)"
                >
                  <b>{{ data.value }}</b>
                </b-button>
              </template>
              <template
                v-slot:cell(modifiedData)="data"
              >
                {{ data.value }}
              </template>
              <template
                v-slot:cell(targets)="data"
              >
                <div>
                  {{ data.value }}
                </div>
              </template>
              <template
                v-slot:cell(fixed)="data"
              >
                <div>
                  <h5>
                    <b-badge
                      v-if="data.value !== ''"
                      variant="success"
                    >
                      {{ data.value }}
                    </b-badge>
                    <b-badge
                      v-if="data.value === '' || data.value.split(',').length !== data.item.targets.split(',').length"
                      variant="danger"
                    >
                      확정안됨
                    </b-badge>
                  </h5>
                </div>
              </template>
              <template
                v-slot:row-details="row"
              >
                <b-card>
                  <donate-regist
                    :target-mobile="row.item.mobile"
                    :target-term="term"
                    :target-donate-id="row.item.donateId"
                    @donateUpdated="getDonateList(term)"
                  />
                </b-card>
              </template>
            </b-table>
          </b-row>
          <b-row
            align-h="center"
            class="my-1"
          >
            <b-col
              cols="5"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../api'
import DonateRegist from './DonateRegist'

export default {
  name: 'DonateList',
  components: { DonateRegist },
  data: function () {
    return {
      filter: null,
      filterOn: ['part', 'nameSchls', 'targets', 'fixed'],
      totalRows: 0,
      currentPage: 1,
      perPage: 100,
      pageOptions: [10, 15, 20, 50, 100],
      term: '',
      termOptions: [],
      itemAll: [],
      noAuth: false,
      fieldsAll: [
        {
          key: 'part',
          label: '구분',
          sortable: true
        },
        {
          key: 'nameSchls',
          label: '장학금이름',
          sortable: true
        },
        {
          key: 'modifiedDate',
          label: '등록일',
          sortable: true,
          formatter: (value, key, item) => {
            return api.unixTimeToDate(value)
          },
          sortByFormatted: true,
          filterByFormatted: true
        },
        {
          key: 'giver',
          label: '수여자',
          sortable: true
        },
        {
          key: 'targets',
          label: '대상',
          sortable: false
        },
        {
          key: 'fixed',
          label: '확정',
          sortable: false
        }
      ]
    }
  },
  mounted () {
    if (this.$store.getters.isSuper) {
      this.getTermList()
    } else {
      this.noAuth = true
      this.$router.push('/dashboard')
    }
  },
  methods: {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    showRowDetail (donateId, val) {
      this.itemAll.forEach(row => {
        if (row.donateId === donateId) {
          row._showDetails = !val
        } else {
          row._showDetails = false
        }
      })
    },
    parseDonate (data) {
      this.itemAll = []
      data.forEach(elem => {
        var item = {}
        item['part'] = elem.part
        item['partName'] = elem.partName
        item['nameSchls'] = elem.nameSchls
        item['modifiedDate'] = elem.modifiedDate
        item['giver'] = elem.giver
        item['targets'] = ''
        elem.targets.forEach(target => {
          if (item['targets'] !== '') {
            item['targets'] += ', '
          }
          item['targets'] += target.target
        })
        item['fixed'] = ''
        elem.fixed.forEach(fix => {
          if (item['fixed'] !== '') {
            item['fixed'] += ', '
          }
          item['fixed'] += fix
        })
        item['donateId'] = elem.donateId
        item['mobile'] = elem.donateId.split('-')[3]
        item['_showDetails'] = false
        this.itemAll.push(item)
      })
      this.totalRows = this.itemAll.length
    },
    getDonateList (term) {
      api.request('get', '/donate/list?term=' + term)
        .then(response => {
          var data = response.data
          this.parseDonate(data.docs)
        })
        .catch(error => {
          alert(error.response.data.error)
        })
    },
    getTermList () {
      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      api.request('get', '/auth/termlist?auth=' + this.$store.state.AUTH)
        .then(response => {
          var data = response.data
          /* result term */
          this.termOptions = []
          data.terms.forEach(term => {
            this.termOptions.push(term)
          })
          if (this.termOptions.length > 0) {
            this.term = this.termOptions[0]
            this.getDonateList(this.term)
          } else {
            // 권한없음
            this.noAuth = true
          }
        })
        .catch(error => {
          alert(error.response.data.error)
        })
    }
  }
}
</script>

<style scoped>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
